import { render, staticRenderFns } from "./src/components/subject-list-item.html?vue&type=template&id=0b29f47f&scoped=true&"
import script from "./src/components/subject-list-item.js?vue&type=script&lang=js&"
export * from "./src/components/subject-list-item.js?vue&type=script&lang=js&"
import style0 from "./src/components/subject-list-item.scss?vue&type=style&index=0&id=0b29f47f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b29f47f",
  null
  
)

export default component.exports